import { DreamBlock } from '@typedream/core';
import { CSSProperties, useContext } from 'react';
import styled from 'styled-components';
import { CanvasContext } from '../../../components/Canvas/context';

function TextWrapper({
  type,
  style,
  children,
}: React.PropsWithChildren<{
  type: string
  style?: CSSProperties
}>) {
  switch (type) {
    case 'h1': {
      const H1 = styled.h1`
          font-size: 56px;
          font-weight: 800;
          line-height: normal;
        `;
      return (
        <H1 style={style}>
          {children}
        </H1>
      );
    }
    case 'h2': {
      const H2 = styled.h2`
        font-size: 36px;
        font-weight: 800;
        line-height: normal;
      `;
      return (
        <H2 style={style}>
          {children}
        </H2>
      );
    }
    case 'h3': {
      const H3 = styled.h3`
        font-size: 26px;
        font-weight: 700;
        line-height: normal;
      `;
      return (
        <H3 style={style}>
          {children}
        </H3>
      );
    }
    case 'p':
      return (
        <p style={style}>
          {children}
        </p>
      );
    default: {
      return null;
    }
  }
}

const StyledPlaceholderContainer = styled.div`
  user-select: none;
  color: var(--text);
  cursor: text;
  line-height: 24px;
  opacity: 0.4;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export function Placeholder({
  element,
  children,
  isRoot,
}: React.PropsWithChildren<{ element: DreamBlock, isRoot: boolean }>) {
  const { scale = 1 } = useContext(CanvasContext);
  return (
    <StyledPlaceholderContainer
      contentEditable={false}
      style={{
        paddingLeft: isRoot ? 30 * scale : 0,
        paddingRight: isRoot ? 30 * scale : 0,
      }}
    >
      <TextWrapper
        type={element.type}
        style={
        scale ? {
          transform: `scale(${scale})`,
          transformOrigin: '0px',
        } : undefined
      }
      >
        {children}
      </TextWrapper>
    </StyledPlaceholderContainer>
  );
}
